import { useEffect } from 'react';
import { useUserState } from '../context/UserContext/UserContext';

const GenesysWrapper = ({ children }) => {
  const userState = useUserState();

  useEffect(() => {
    if (!window.Genesys) {
      console.error('Genesys is not available');
      return;
    }
    const handleMessengerOpened = () => {
      window.Genesys('command', 'Database.update', {
        messaging: {
          customAttributes: {
            ID: userState.amisId,
            Name: userState.firstName + ' ' + userState.lastName,
            Phone: userState.phoneNumber,
          },
        },
      });
    };

    window.Genesys('subscribe', 'Messenger.opened', () => {
      if (userState?.amisId) {
        handleMessengerOpened();
      }
    });

    return () => {};
  }, [userState]);

  return children;
};

export default GenesysWrapper;
